export function pagetop() {
  $(function(){
    if (window.matchMedia('(max-width: 767px)').matches) {
      var pos = 0;
      $(window).on('scroll', function(){
        //ユーザーのスクロール位置取得　& スクロール方向で分岐
        if($(this).scrollTop() < pos ){
          //上スクロール時の処理を記述
          $('.p-scroll_btn').addClass('is-viewsp');
        }else{
          //下スクロール時の処理を記述
          $('.p-scroll_btn').removeClass('is-viewsp');
        }
        //スクロールが停止した位置を保持
        pos = $(this).scrollTop();
      });
    }
  });
}